export const AscBadgeColor = {
  TEAL: 'TEAL',
  PINK: 'PINK',
  GREEN: 'GREEN',
  PURPLE: 'PURPLE',
  ORANGE: 'ORANGE',
} as const;

export const AscTrackBadgeColor = {
  /**
   * Entrepreneurship
   */
  DARK_ORANGE: 'DARK_ORANGE',
  /**
   * Internship
   */
  TURQUOISE: 'TURQUOISE',
} as const;

export type AscBadgeColor = (typeof AscBadgeColor)[keyof typeof AscBadgeColor];
export type AscTrackBadgeColor =
  (typeof AscTrackBadgeColor)[keyof typeof AscTrackBadgeColor];
